import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{key:_vm.mkey},[_c('div',{staticClass:"flex",staticStyle:{"display":"flex","align-items":"center"}},[_c(VListItemContent,{staticClass:"font-weight-medium pa-0",staticStyle:{"margin-right":"8px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }